import React, { useEffect, useState } from 'react';
import { Button, Grid2 as Grid, Box, useMediaQuery } from '@mui/material';
import { Add, Delete, Edit, Save, Undo } from '@mui/icons-material';
import {
  Actions,
  useDispatchProvider,
  useStateFormCustomer,
  useStateFormOrder,
  useStateFormSupplier,
  useStateFormTransaction,
  useStateFormUser,
} from '../utils/StateProvider';
import SkeletonForm from '../utils/SkeletonForm';
import { addDoc, collection, deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore';
import { auth, db } from '../../config/firebase';
import { useForm } from 'react-hook-form';
import FieldTextarea from '../fields/FieldTextArea';
import { formatDateTime, getNewDateTime, parseDateTime } from '../../utils/utils';
import FieldText from '../fields/FieldText';
import FieldCurrency from '../fields/FieldCurrency';
import { createPortal } from 'react-dom';
import { usePermissions } from '../utils/AclProvider';
import FieldDateTime from '../fields/FieldDateTime';
import FieldSelect from '../fields/FieldSelect';
import { transactionCounterStatuses, transactionPersonalStatuses, transactionStatuses } from '../../data/statuses';
import FieldUserAutocomplete from '../fields/FieldUserAutocomplete';
import FieldSupplierAutocomplete from '../fields/FieldSupplierAutocomplete';
import FieldCustomerAutocomplete from '../fields/FieldCustomerAutocomplete';

const FormTransaction = ({ portalRef }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const permissions = usePermissions();
  const stateFormTransaction = useStateFormTransaction();
  const stateFormSupplier = useStateFormSupplier();
  const stateFormCustomer = useStateFormCustomer();
  const stateFormUser = useStateFormUser();
  const stateFormOrder = useStateFormOrder();
  const dispatch = useDispatchProvider();
  const [stateStatusDisabled, setStateStatusDisabled] = useState(false);

  const handleDialogDelete = () => {
    dispatch &&
      dispatch({
        type: Actions.DialogDelete,
        payload: {
          open: true,
          title: 'Are you sure you want to delete this transaction?',
          onConfirm: deleteTransaction,
        },
      });
  };

  const handleTransactionNew = (transactionRefId) => {
    dispatch &&
      dispatch({
        type: Actions.FormTransactionNew,
        payload: transactionRefId,
      });
  };

  const [stateForm, setStateForm] = useState('create');
  const [stateLoading, setStateLoading] = useState(true);
  const [stateSaving, setStateSaving] = useState(false);

  const transactionDocRef = stateFormTransaction ? doc(db, 'transactions', stateFormTransaction) : null;
  const transactionsCollectionRef = collection(db, 'transactions');

  const formDefaultValues = {
    blackPayment: 0,
    comments: '',
    transactionStatus: '',
    counterStatus: '',
    personalStatus: '',
    dateCreated: formatDateTime(getNewDateTime()),
    dateUpdated: '',
    userCreated: '',
    userUpdated: '',
    downPayment: 0,
    error: 0,
    invoicePayment: 0,
    taxesPayment: 0,
    reason: '',
    sequenceTotal: 0,
    supplierRef: '',
    customerRef: '',
    userRef: '',
    orderRef: '',
    total: 0,
  };
  const { control, getValues, reset, setValue, watch } = useForm({
    defaultValues: formDefaultValues,
  });

  const transactionStatusWatch = watch('transactionStatus');

  const fetchTransaction = async () => {
    if (stateFormTransaction === '') {
      reset();
      setStateForm('create');
      return;
    }

    try {
      const docSnap = await getDoc(transactionDocRef);

      if (docSnap.exists()) {
        setStateForm('edit');
        const transactionData = docSnap.data();
        reset({
          ...transactionData,
          dateCreated: formatDateTime(transactionData.dateCreated),
          dateUpdated: formatDateTime(transactionData.dateUpdated),
          customerRef: transactionData.customerRef?.id,
          userRef: transactionData.userRef?.id,
          supplierRef: transactionData.supplierRef?.id,
          orderRef: transactionData.orderRef?.id,
        });
        // setValue('reason', transactionData.reason);
        // setValue('comments', transactionData.comments);
        // setValue('transactionStatus', transactionData.transactionStatus);
        // setValue('counterStatus', transactionData.counterStatus);
        // setValue('blackPayment', transactionData.blackPayment);
        // setValue('dateCreated', formatDateTime(transactionData.dateCreated));
        // setValue('downPayment', transactionData.downPayment);
        // setValue('taxesPayment', transactionData.taxesPayment);
        // setValue('error', transactionData.error);
        // setValue('invoicePayment', transactionData.invoicePayment);
        // setValue('sequenceTotal', transactionData.sequenceTotal);
        // setValue('total', transactionData.total);
      } else {
        dispatch &&
          dispatch({
            type: Actions.Snackbar,
            payload: { open: true, severity: 'error', message: `No transaction found!` },
          });
      }
    } catch (err) {
      dispatch &&
        dispatch({
          type: Actions.Snackbar,
          payload: { open: true, severity: 'error', message: `Error fetching transaction: ${err.message}` },
        });
    }
  };

  const editTransaction = () => {
    setStateForm('save');
  };

  const revertTransaction = () => {
    setStateForm('edit');
    fetchTransaction().then();
  };
  // const onSubmit = (data) => {
  //   console.log(data);
  // };
  const addTransaction = async () => {
    // console.log('addTransaction', stateFormCustomer, stateFormSupplier);
    // const transactionForm = getValues();
    // console.log('transactionForm', transactionForm);
    // console.log('supplierDocRef', supplierDocRef);
    // console.log('customerDocRef', customerDocRef);
    // console.log('calculateSequenceTotal', calculateSequenceTotal(transactionForm));
    // console.log('transactionForm', transactionForm);
    // return;
    try {
      setStateSaving(true);
      const transactionForm = getValues();
      const supplierDocRef = transactionForm.supplierRef ? doc(db, 'suppliers', transactionForm.supplierRef) : null;
      const customerDocRef = transactionForm.customerRef ? doc(db, 'customers', transactionForm.customerRef) : null;
      const userDocRef = transactionForm.userRef ? doc(db, 'users', transactionForm.userRef) : null;
      const orderDocRef = transactionForm.orderRef ? doc(db, 'orders', transactionForm.orderRef) : null;
      let newTotal = 0;
      if (transactionForm.transactionStatus === 'purchases' && supplierDocRef) {
        newTotal = calculateSequenceTotal(transactionForm);
      }
      if (transactionForm.transactionStatus === 'extras' && customerDocRef) {
        newTotal = calculateSequenceTotalCustomer(transactionForm);
      }
      if (transactionForm.transactionStatus === 'expenses' && userDocRef) {
        newTotal = calculateSequenceTotalCustomer(transactionForm);
      }
      if (!transactionForm.transactionStatus === 'counter') {
        delete transactionForm.counterStatus;
      }
      if (!transactionForm.transactionStatus === 'personal') {
        delete transactionForm.personalStatus;
      }

      const newTransactionDocRef = await addDoc(transactionsCollectionRef, {
        ...transactionForm,
        total: newTotal,
        supplierRef: (transactionForm.transactionStatus === 'purchases' && supplierDocRef) || '',
        customerRef: (transactionForm.transactionStatus === 'extras' && customerDocRef) || '',
        orderRef: (transactionForm.transactionStatus === 'extras' && orderDocRef) || '',
        userRef: (transactionForm.transactionStatus === 'expenses' && userDocRef) || '',
        dateCreated: parseDateTime(transactionForm.dateCreated),
        userCreated: auth.currentUser.displayName,
      }).then(async (transactionDocRef) => {
        setStateSaving(false);
        setStateForm('edit');

        if (transactionDocRef.id) {
          // console.log('addTransaction', transactionDocRef.id);
          handleTransactionNew(transactionDocRef.id);
        }

        dispatch &&
          dispatch({
            type: Actions.DialogTransaction,
            payload: false,
          });

        dispatch &&
          dispatch({
            type: Actions.Snackbar,
            payload: {
              open: true,
              severity: 'success',
              message: `Successfully added new transaction: ${transactionForm.dateCreated}`,
            },
          });
      });
    } catch (err) {
      setStateSaving(false);
      dispatch &&
        dispatch({
          type: Actions.Snackbar,
          payload: { open: true, severity: 'error', message: `Error adding new transaction: ${err.message}` },
        });
    }
  };

  const saveTransaction = async () => {
    try {
      setStateSaving(true);
      const transactionForm = getValues();
      const supplierDocRef = transactionForm.supplierRef ? doc(db, 'suppliers', transactionForm.supplierRef) : null;
      const customerDocRef = transactionForm.customerRef ? doc(db, 'customers', transactionForm.customerRef) : null;
      const userDocRef = transactionForm.userRef ? doc(db, 'users', transactionForm.userRef) : null;
      const orderDocRef = transactionForm.orderRef ? doc(db, 'orders', transactionForm.orderRef) : null;
      let newTotal = 0;
      if (transactionForm.transactionStatus === 'purchases' && supplierDocRef) {
        newTotal = calculateSequenceTotal(transactionForm);
      }
      if (transactionForm.transactionStatus === 'extras' && customerDocRef) {
        newTotal = calculateSequenceTotalCustomer(transactionForm);
      }
      if (transactionForm.transactionStatus === 'expenses' && userDocRef) {
        newTotal = calculateSequenceTotalCustomer(transactionForm);
      }
      if (!transactionForm.transactionStatus === 'counter') {
        delete transactionForm.counterStatus;
      }
      if (!transactionForm.transactionStatus === 'personal') {
        delete transactionForm.personalStatus;
      }
      delete transactionForm.supplierRef;
      delete transactionForm.customerRef;
      delete transactionForm.orderRef;
      delete transactionForm.userRef;
      await updateDoc(transactionDocRef, {
        ...transactionForm,
        total: newTotal,
        supplierRef: (transactionForm.transactionStatus === 'purchases' && supplierDocRef) || '',
        customerRef: (transactionForm.transactionStatus === 'extras' && customerDocRef) || '',
        orderRef: (transactionForm.transactionStatus === 'extras' && orderDocRef) || '',
        userRef: (transactionForm.transactionStatus === 'expenses' && userDocRef) || '',
        dateCreated: parseDateTime(transactionForm.dateCreated),
        dateUpdated: getNewDateTime(),
        userUpdated: auth.currentUser.displayName,
      }).then(() => {
        setStateForm('edit');
        setStateSaving(false);
        dispatch &&
          dispatch({
            type: Actions.Snackbar,
            payload: {
              open: true,
              severity: 'success',
              message: `Successfully update transaction: ${transactionForm.dateCreated}`,
            },
          });
        dispatch &&
          dispatch({
            type: Actions.DialogTransaction,
            payload: false,
          });
      });
    } catch (err) {
      setStateSaving(false);
      dispatch &&
        dispatch({
          type: Actions.Snackbar,
          payload: { open: true, severity: 'error', message: `Error saving transaction: ${err.message}` },
        });
    }
  };

  const deleteTransaction = async () => {
    try {
      setStateSaving(true);
      await deleteDoc(transactionDocRef).then(() => {
        setStateSaving(false);
        if (dispatch) {
          dispatch({
            type: Actions.Snackbar,
            payload: { open: true, severity: 'success', message: 'Successfully delete transaction' },
          });

          dispatch({
            type: Actions.FormTransaction,
            payload: '',
          });

          dispatch({
            type: Actions.DialogDelete,
            payload: { open: false, title: '', onConfirm: () => {} },
          });

          dispatch({
            type: Actions.DialogTransaction,
            payload: false,
          });
        }
      });
    } catch (err) {
      setStateSaving(false);
      dispatch({
        type: Actions.Snackbar,
        payload: { open: true, severity: 'error', message: `Error deleting customer: ${err}` },
      });
    }
  };

  const calculateSequenceTotal = (transactionForm) => {
    return (
      transactionForm.blackPayment +
      transactionForm.invoicePayment +
      transactionForm.taxesPayment -
      transactionForm.downPayment -
      transactionForm.error
    );
  };

  const calculateSequenceTotalCustomer = (transactionForm) => {
    return (
      (transactionForm.blackPayment +
        transactionForm.invoicePayment +
        transactionForm.taxesPayment -
        transactionForm.downPayment -
        transactionForm.error) *
      -1
    );
  };

  // useEffect(() => {
  //   setStateLoading(true);
  //   fetchTransaction().then(() => {
  //     setStateLoading(false);
  //   });
  // }, [stateFormTransaction]);

  useEffect(() => {
    setStateLoading(true);
    // console.log('useEffect', stateFormTransaction, stateFormCustomer, stateFormSupplier, stateFormUser);
    if (stateFormTransaction !== '') {
      fetchTransaction().then(() => {
        setStateLoading(false);
      });
    } else if (stateFormCustomer !== '') {
      reset({
        ...formDefaultValues,
        transactionStatus: 'extras',
        customerRef: stateFormCustomer,
        supplierRef: '',
        userRef: '',
        orderRef: stateFormOrder,
      });
      setStateStatusDisabled(true);
      setStateLoading(false);
    } else if (stateFormSupplier !== '') {
      reset({
        ...formDefaultValues,
        transactionStatus: 'purchases',
        customerRef: '',
        supplierRef: stateFormSupplier,
        userRef: '',
        orderRef: '',
      });
      setStateStatusDisabled(true);
      setStateLoading(false);
    } else if (stateFormUser !== '') {
      reset({
        ...formDefaultValues,
        transactionStatus: 'expenses',
        customerRef: '',
        supplierRef: '',
        userRef: stateFormUser,
        orderRef: '',
      });
      setStateStatusDisabled(true);
      setStateLoading(false);
    } else {
      reset({
        ...formDefaultValues,
        transactionStatus: '',
        customerRef: '',
        orderRef: '',
        supplierRef: '',
        userRef: '',
      });
      setStateStatusDisabled(false);
      setStateLoading(false);
    }
  }, [stateFormTransaction, stateFormCustomer, stateFormOrder, stateFormSupplier, stateFormUser]);

  return (
    <Box component={'form'}>
      <>
        {stateLoading ? (
          <SkeletonForm />
        ) : (
          <Grid
            container
            spacing={3}
          >
            <Grid size={12}>
              <FieldSelect
                label={'Status'}
                name={'transactionStatus'}
                control={control}
                options={transactionStatuses}
                disabled={stateForm === 'edit' || stateStatusDisabled}
                setValue={setValue}
              />
            </Grid>
            {transactionStatusWatch === 'expenses' && (
              <Grid size={12}>
                <FieldUserAutocomplete
                  label={'User'}
                  name={'userRef'}
                  control={control}
                  disabled={stateForm === 'edit' || stateStatusDisabled}
                />
              </Grid>
            )}
            {transactionStatusWatch === 'purchases' && (
              <Grid size={12}>
                <FieldSupplierAutocomplete
                  label={'Supplier'}
                  name={'supplierRef'}
                  control={control}
                  disabled={stateForm === 'edit' || stateStatusDisabled}
                />
              </Grid>
            )}
            {transactionStatusWatch === 'extras' && (
              <>
                <Grid size={12}>
                  <FieldCustomerAutocomplete
                    label={'Customer'}
                    name={'customerRef'}
                    control={control}
                    disabled={stateForm === 'edit' || stateStatusDisabled}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldText
                    label={'Order'}
                    name={'orderRef'}
                    control={control}
                    disabled={true}
                  />
                </Grid>
              </>
            )}
            {transactionStatusWatch === 'counter' && (
              <Grid size={12}>
                <FieldSelect
                  label={'Counter status'}
                  name={'counterStatus'}
                  control={control}
                  options={transactionCounterStatuses}
                  disabled={stateForm === 'edit' || stateStatusDisabled}
                  setValue={setValue}
                />
              </Grid>
            )}
            {transactionStatusWatch === 'personal' && (
              <Grid size={12}>
                <FieldSelect
                  label={'Personal status'}
                  name={'personalStatus'}
                  control={control}
                  options={transactionPersonalStatuses}
                  disabled={stateForm === 'edit' || stateStatusDisabled}
                  setValue={setValue}
                />
              </Grid>
            )}
            <Grid size={12}>
              <FieldTextarea
                label={'Comments'}
                name={'comments'}
                control={control}
                disabled={stateForm === 'edit'}
              />
            </Grid>
            <Grid size={12}>
              <FieldTextarea
                label={'Reason'}
                name={'reason'}
                control={control}
                disabled={stateForm === 'edit'}
              />
            </Grid>
            {['purchases', 'extras', 'expenses'].includes(transactionStatusWatch) && (
              <Grid size={12}>
                <FieldCurrency
                  label={'D.Note'}
                  name={'blackPayment'}
                  control={control}
                  disabled={stateForm === 'edit'}
                  setValue={setValue}
                />
              </Grid>
            )}
            {['purchases', 'extras'].includes(transactionStatusWatch) && (
              <>
                <Grid size={12}>
                  <FieldCurrency
                    label={'Invoice'}
                    name={'invoicePayment'}
                    control={control}
                    disabled={stateForm === 'edit'}
                    setValue={setValue}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCurrency
                    label={'Taxes'}
                    name={'taxesPayment'}
                    control={control}
                    disabled={stateForm === 'edit'}
                    setValue={setValue}
                  />
                </Grid>
                <Grid size={12}>
                  <FieldCurrency
                    label={'Error correction'}
                    name={'error'}
                    control={control}
                    disabled={stateForm === 'edit'}
                    setValue={setValue}
                  />
                </Grid>
              </>
            )}
            <Grid size={12}>
              <FieldCurrency
                label={'Down payment'}
                name={'downPayment'}
                control={control}
                disabled={stateForm === 'edit'}
                setValue={setValue}
              />
            </Grid>

            {/*{(stateFormCustomer || stateFormSupplier) && (*/}
            {/*  <>*/}
            <Grid size={12}>
              <FieldCurrency
                label={'Total'}
                name={'total'}
                control={control}
                disabled={true}
                setValue={setValue}
              />
            </Grid>
            <Grid size={12}>
              <FieldCurrency
                label={'Sequence total'}
                name={'sequenceTotal'}
                control={control}
                disabled={true}
                setValue={setValue}
              />
            </Grid>
            {/*  </>*/}
            {/*)}*/}
            <Grid size={12}>
              <Grid
                container
                spacing={2}
              >
                <Grid size={6}>
                  <FieldDateTime
                    label={'Date created'}
                    name={'dateCreated'}
                    control={control}
                    setValue={setValue}
                    // disabled={true}
                    disabled={stateForm === 'edit'}
                  />
                </Grid>
                <Grid size={6}>
                  <FieldText
                    label={'User created'}
                    name={'userCreated'}
                    control={control}
                    disabled={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid size={12}>
              <Grid
                container
                spacing={2}
              >
                <Grid size={6}>
                  <FieldDateTime
                    label={'Date updated'}
                    name={'dateUpdated'}
                    control={control}
                    disabled={true}
                  />
                </Grid>
                <Grid size={6}>
                  <FieldText
                    label={'User updated'}
                    name={'userUpdated'}
                    control={control}
                    disabled={true}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
        {portalRef.current &&
          createPortal(
            <>
              <Grid
                container
                spacing={3}
                justifyContent="flex-end"
              >
                {stateForm === 'edit' && permissions?.transactions?.update && (
                  <Grid size={'auto'}>
                    <Button
                      color={'primary'}
                      variant={'contained'}
                      startIcon={<Edit />}
                      onClick={editTransaction}
                      size={isMobile ? 'small' : 'large'}
                      loading={stateSaving}
                    >
                      Edit
                    </Button>
                  </Grid>
                )}
                {stateForm === 'save' && permissions?.transactions?.update && (
                  <Grid size={'auto'}>
                    <Button
                      color={'primary'}
                      variant={'text'}
                      startIcon={<Undo />}
                      onClick={revertTransaction}
                      size={isMobile ? 'small' : 'large'}
                      loading={stateSaving}
                    >
                      Undo
                    </Button>
                  </Grid>
                )}
                {stateForm === 'save' && permissions?.transactions?.delete && (
                  <Grid size={'auto'}>
                    <Button
                      color={'primary'}
                      variant={'text'}
                      startIcon={<Delete />}
                      onClick={handleDialogDelete}
                      size={isMobile ? 'small' : 'large'}
                      loading={stateSaving}
                    >
                      Delete
                    </Button>
                  </Grid>
                )}
                {stateForm === 'save' && permissions?.transactions?.update && (
                  <Grid size={'auto'}>
                    <Button
                      color={'primary'}
                      variant={'contained'}
                      startIcon={<Save />}
                      onClick={saveTransaction}
                      size={isMobile ? 'small' : 'large'}
                      loading={stateSaving}
                    >
                      Save
                    </Button>
                  </Grid>
                )}
                {stateForm === 'create' && permissions?.transactions?.create && (
                  <Grid size={'auto'}>
                    <Button
                      color={'primary'}
                      variant={'contained'}
                      startIcon={<Add />}
                      onClick={addTransaction}
                      size={isMobile ? 'small' : 'large'}
                      loading={stateSaving}
                    >
                      Create
                    </Button>
                  </Grid>
                )}
              </Grid>
            </>,
            portalRef.current,
          )}
      </>
    </Box>
  );
};

export default FormTransaction;
